import { REPORT_TABLE_MODAL_CELL_NAME } from '../../../../../ReportTableModal'

export const POST_REPORTS_VIEWS_TAB = 'views'

export const POST_REPORTS_LIKES_TAB = 'likes'

export const POST_REPORTS_VIEWERS_COLUMNS_CONFIG = {
  [REPORT_TABLE_MODAL_CELL_NAME.building]: {
    index: 4,
    name: REPORT_TABLE_MODAL_CELL_NAME.building,
    ordering_field: null,
    title: 'Modal.PostReportsViewsColumnAddressKey',
    visible: true,
    width: 415,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.date]: {
    index: 1,
    name: REPORT_TABLE_MODAL_CELL_NAME.date,
    ordering_field: REPORT_TABLE_MODAL_CELL_NAME.date,
    title: 'Modal.PostReportsViewColumnDateKey',
    visible: true,
    width: 232,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.email]: {
    index: 2,
    name: REPORT_TABLE_MODAL_CELL_NAME.email,
    ordering_field: REPORT_TABLE_MODAL_CELL_NAME.email,
    title: 'Modal.PostReportsViewColumnEmailKey',
    visible: true,
    width: 240,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.owner]: {
    index: 0,
    name: REPORT_TABLE_MODAL_CELL_NAME.owner,
    ordering_field: 'fullname',
    title: 'Modal.PostReportsViewColumnNameKey',
    visible: true,
    width: 240,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.role]: {
    index: 3,
    name: REPORT_TABLE_MODAL_CELL_NAME.role,
    ordering_field: REPORT_TABLE_MODAL_CELL_NAME.role,
    title: 'Modal.PostReportsViewColumnRoleKey',
    visible: true,
    width: 200,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.status]: {
    index: 5,
    name: REPORT_TABLE_MODAL_CELL_NAME.status,
    ordering_field: REPORT_TABLE_MODAL_CELL_NAME.status,
    title: 'Modal.PostReportsViewColumnStatusKey',
    visible: true,
    width: 176,
  },
}

export const POST_REPORTS_LIKES_COLUMNS_CONFIG = {
  [REPORT_TABLE_MODAL_CELL_NAME.building]: {
    index: 4,
    name: REPORT_TABLE_MODAL_CELL_NAME.building,
    ordering_field: null,
    title: 'Modal.PostReportsLikesColumnAddressKey',
    visible: true,
    width: 415,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.date]: {
    index: 1,
    name: REPORT_TABLE_MODAL_CELL_NAME.date,
    ordering_field: REPORT_TABLE_MODAL_CELL_NAME.date,
    title: 'Modal.PostReportsLikesColumnDateKey',
    visible: true,
    width: 232,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.email]: {
    index: 2,
    name: REPORT_TABLE_MODAL_CELL_NAME.email,
    ordering_field: REPORT_TABLE_MODAL_CELL_NAME.email,
    title: 'Modal.PostReportsLikesColumnEmailKey',
    visible: true,
    width: 240,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.owner]: {
    index: 0,
    name: REPORT_TABLE_MODAL_CELL_NAME.owner,
    ordering_field: 'fullname',
    title: 'Modal.PostReportsLikesColumnNameKey',
    visible: true,
    width: 240,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.role]: {
    index: 3,
    name: REPORT_TABLE_MODAL_CELL_NAME.role,
    ordering_field: REPORT_TABLE_MODAL_CELL_NAME.role,
    title: 'Modal.PostReportsLikesColumnRoleKey',
    visible: true,
    width: 200,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.status]: {
    index: 5,
    name: REPORT_TABLE_MODAL_CELL_NAME.status,
    ordering_field: REPORT_TABLE_MODAL_CELL_NAME.status,
    title: 'Modal.PostReportsLikesColumnStatusKey',
    visible: true,
    width: 176,
  },
}
